import React from "react";
import InnerCircleCard from "./InnerCircleCard"
import InnerFeedCard from "./InnerFeedCard"
import { useLocation } from "react-router-dom";

const FeedInnerCircle = () => {
  const { state } = useLocation();
  return (
    <div className="w-full bg-background">
      <div className="w-[80%] mx-auto pt-10">
        <div className="flex gap-4">
          <div className="w-[60%]">
            <InnerCircleCard id={state.id} myid={state.myid} />
          </div>
          <div className="w-[40%]">
            <InnerFeedCard id={state.id} myid={state.myid} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedInnerCircle;
